import { Route } from '@angular/router';
import { LoggedInGuard, PendingChangesGuard } from '@spotter/guards/login-guard';

/** Adds the routes for sighting pages. */
export function addSightingPageRoutes(): Route[] {
  return [
    {
      path: 'sightings/upload', canActivate: [LoggedInGuard], canDeactivate: [PendingChangesGuard],
      loadComponent: () => import('../pages/sightings/upload-page/upload-page.component').then(m => m.UploadPageComponent)
    },
    {
      path: 'sightings/grid',
      loadComponent: () => import('../pages/sightings/grid-page/grid-page.component').then(m => m.GridPageComponent)
    },
    {
      path: 'sightings/map',
      loadComponent: () => import('../pages/sightings/map-page/map-page.component').then(m => m.MapPageComponent)
    },
    {
      path: 'sighting/:id',
      loadComponent: () => import('../pages/sightings/single-sighting-page/single-sighting-page.component').then(m => m.SingleSightingPageComponent)
    },
    {
      path: 'sighting/:id/edit',
      loadComponent: () => import('../pages/sightings/edit-sighting-page/edit-sighting-page.component').then(m => m.EditSightingPageComponent)
    },
  ];
}